import { getRandomParameters } from '@/shared/plugins/freewheel/helpers';

export default {
  data() {
    return {
      info: this.$services.resolve('info'),
    };
  },
  computed: {
    getCompanionSlid() {
      const { width = 320, height = 50 } = this.info.companionBanner;
      const { vprn, pvrn } = getRandomParameters();
      return `slid=companion_slot&vprn=${vprn}&pvrn=${pvrn}&ptgt=p&w=${width}&h=${height}&tpcl=DISPLAY&flag=+cmpn+fcai`;
    },
  },
};
